export default {
  NONE : 'NONE',
  FREE : 'FREE',
  PAID : 'PAID',
  IOS_DISABLED : 'IOS_DISABLED',
}
